import { NgModule } from '@angular/core';
import { FilterPipe } from '@core/pipes/filter.pipe';
import { SumPipe } from '@core/pipes/sum.pipe';
import { AvgPipe } from '@core/pipes/avg.pipe';
import { InitialsPipe } from '@core/pipes/initials.pipe';
import { SafePipe } from '@core/pipes/safe.pipe';
import { StripHtmlPipe } from '@core/pipes/stripHtml.pipe';

@NgModule({
  declarations: [InitialsPipe, FilterPipe, StripHtmlPipe, SafePipe, SumPipe, AvgPipe],
  imports: [],
  exports: [InitialsPipe, FilterPipe, StripHtmlPipe, SafePipe, SumPipe, AvgPipe]
})
export class CorePipesModule { }
